const FragmentBadges = ({ fragment, currentPromptFragments, needsUpdate }) => {
  let fragmentInUse = [];

  if (currentPromptFragments.length > 0) {
    fragmentInUse = currentPromptFragments.find(
      (f) => f.prompt_fragment_id === fragment.id
    );
  }

  return (
    <>
      {fragmentInUse?.found_in_pre_processing && (
        <div className="text-xs px-2 py-1 rounded-full bg-green-600 text-white mr-1">
          Pre
        </div>
      )}
      {fragmentInUse?.found_in_primary && (
        <div className="text-xs px-2 py-1 rounded-full bg-purple-600 text-white mr-1">
          Primary
        </div>
      )}
      {fragmentInUse?.found_in_post_processing && (
        <div className="text-xs px-2 py-1 rounded-full bg-indigo-600 text-white mr-1">
          Post
        </div>
      )}
      <div
        className={`text-xs px-2 py-1 rounded-full ${
          needsUpdate ? "bg-yellow-600 text-white" : "bg-blue-600 text-white"
        }`}
      >
        {needsUpdate
          ? `v${fragmentInUse?.version} → v${fragment?.latest}`
          : `v${fragmentInUse?.version}`}
      </div>
    </>
  );
};

export default FragmentBadges;
